/*
 * Durnev Collection — infinite scroll for the product grid.
 * Watches the .durnev-coll-grid__sentinel placed after the grid; when it
 * intersects the viewport, fetches the next paginated URL, extracts the
 * new product cards from the response and appends them to the current grid.
 */
(function () {
  'use strict';

  function init(sentinel) {
    if (!sentinel || sentinel.dataset.infiniteAttached === '1') return;
    sentinel.dataset.infiniteAttached = '1';

    var gridId = sentinel.dataset.gridId;
    var grid = gridId ? document.getElementById(gridId) : null;
    if (!grid) return;

    var loading = false;

    function setLoading(state) {
      loading = state;
      sentinel.classList.toggle('is-loading', state);
    }

    function detach() {
      if (observer) observer.disconnect();
      sentinel.remove();
    }

    function loadMore() {
      if (loading) return;
      var url = sentinel.dataset.nextUrl;
      if (!url) {
        detach();
        return;
      }
      setLoading(true);

      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById(gridId);
          if (!newGrid) {
            detach();
            return;
          }

          var newCards = newGrid.querySelectorAll('.durnev-coll-card');
          var frag = document.createDocumentFragment();
          newCards.forEach(function (card) { frag.appendChild(card); });
          grid.appendChild(frag);

          var newSentinel = doc.querySelector('.durnev-coll-grid__sentinel[data-grid-id="' + gridId + '"]');
          if (newSentinel && newSentinel.dataset.nextUrl) {
            sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
            setLoading(false);
          } else {
            detach();
          }
        })
        .catch(function (err) {
          console.error('[durnev-infinite] load failed', err);
          setLoading(false);
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadMore();
      });
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
  }

  function boot() {
    document.querySelectorAll('.durnev-coll-grid__sentinel').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-attach on Shopify section reload (theme editor) and after facet filters update the grid.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('facets:loaded', boot);
})();
